<template>
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 24 24" fill="currentColor">
    <path
      d="M18.5 5.9V4.4c0-.9-.8-1.7-1.7-1.7H5c-.9 0-1.7.8-1.7 1.7v9c0 .9.8 1.7 1.7 1.7h3.8l-1.7 6.2h1.1l1.8-6.2h2l1.8 6.2h1.1l-1.8-6.2h3.6c.9 0 1.7-.8 1.7-1.7v-1.5l4.5 1.7V4.2l-4.5 1.7Zm3.3 6.2-4.5-1.7v3c0 .3-.3.6-.6.6H5c-.3 0-.6-.3-.6-.6v-9c0-.3.3-.6.6-.6h11.8c.3 0 .6.3.6.6v3l4.5-1.7V12ZM2.2 6.7H1.1v4.5h1.1V6.7Z"
    />
  </svg>
</template>
